module.exports = __webpack_public_path__ + "img/candles-on.1b8a4224.png";